export enum EnvironmentNames {
  local = 'local',
  development = 'dev',
  integration = 'int',
  production = 'prod',
}

export const checkEnvironment = () => {
  const environment = process.env.REACT_APP_ENV as string;
  return environment;
};

export const deployUpTo = (target: string) => {
  const currentEnvironment = checkEnvironment();
  const BreakException = {};
  let environmentSwitch = true;
  try {
    Object.entries(EnvironmentNames).forEach((environmentName) => {
      if (environmentName[1] === target) environmentSwitch = false;
      if (environmentName[1] === currentEnvironment) throw BreakException;
    });
  } catch (error) {
    if (error !== BreakException) throw error;
  }
  if (target === currentEnvironment) return true;
  return environmentSwitch;
};